export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12906.18d42ef6.jpg";